module.exports = __webpack_public_path__ + "static/media/ne.f08d970d.svg";